import { render, staticRenderFns } from "./RegisterConfirm.vue?vue&type=template&id=7f30cf15&scoped=true"
import script from "./RegisterConfirm.vue?vue&type=script&lang=js"
export * from "./RegisterConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f30cf15",
  null
  
)

export default component.exports